module.exports = __webpack_public_path__ + "img/prize_bg.5640b4b1.png";